module.exports = __webpack_public_path__ + "0d9e4566bc7e6260c798b2e59dea17f7.pdf";